module.exports = __webpack_public_path__ + "static/media/iconService5.6e1461a9.svg";